import { render, staticRenderFns } from "./main-item.vue?vue&type=template&id=441dc50e&scoped=true"
import script from "./main-item.vue?vue&type=script&lang=js"
export * from "./main-item.vue?vue&type=script&lang=js"
import style0 from "./main-item.vue?vue&type=style&index=0&id=441dc50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441dc50e",
  null
  
)

export default component.exports